<div class="wrapper {{ pdfService.displayViewer ? 'hide-scrollbar' : '' }}">
  <div class="sidebar" data-color="white" data-active-color="danger">
    <sidebar-cmp></sidebar-cmp>
  </div>
  <div class="main-panel">
    <navbar-cmp></navbar-cmp>
    <div class="content">
      <div class="form-row">
        <div class="col-12">
          <div class="card" *ngIf="authenticationService.isAuthenticated()">
            <div class="card-body">
              <div class="float-right">
                <strong>{{ "Bienvenido(a): " | uppercase }} </strong>
                <span>
                  {{ (authenticationService.userSubject | async)?.FullName }}
                </span>
              </div>
            </div>
          </div>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <footer-cmp></footer-cmp>
  </div>
</div>
